import { AppLanguage } from '../model/enums/AppLanguage';

const languages = Object.values(AppLanguage) as string[];

/**
 * Returns the language prefix of a pathname ('/en' for '/en/poradenstvi') or an
 * empty string when the path is not language prefixed (the default Czech routes).
 */
export const languagePrefix = (pathname: string): string => {
  const lang = pathname.match(/^\/([a-z]{2})(?:\/|$)/)?.[1];
  return lang && languages.includes(lang) ? `/${lang}` : '';
};

/**
 * Keeps the currently selected language when linking to another page,
 * e.g. localizedPath('/en/poradenstvi', '/') === '/en'.
 */
export const localizedPath = (pathname: string, path: string): string => {
  const prefix = languagePrefix(pathname);
  const target = path === '/' ? '' : path;
  return `${prefix}${target}` || '/';
};

/**
 * Path without the language prefix, used to build canonical URLs so that the
 * localized variants of a page all point at one canonical address.
 */
export const unprefixedPath = (pathname: string): string => {
  const withoutPrefix = pathname.slice(languagePrefix(pathname).length).replace(/\/+$/, '');
  return withoutPrefix || '/';
};
